module.exports = __webpack_public_path__ + "img/2.c416a8dc.png";